import { Box } from "@mui/material";
import moment from "moment";
import { getStatusLabel } from "../../Utils/DecideStatus";
import { getCellStyle } from "../../Utils/DecideColor";
import StatusBadge from "../StatusBadge";
import { formatCellValue,formatDateForDisplay } from "../../Utils/UtilityFunctions";

export const subscriptionColumns = [
  {
    accessorKey: 'subscriptionId',
    header: 'Subscription ID',
    size: 200,
   Cell: ({ cell }) => formatCellValue(cell.getValue())
  },
  {
    accessorKey: 'offerName',
    header: 'Offer Name',
    size: 200,
   Cell: ({ cell }) => formatCellValue(cell.getValue())
  },
  {
    accessorKey: 'validFrom',
    header: 'Offer Starts',
    Cell: ({ cell }) => formatCellValue(cell.getValue(),val=> moment(val).format("DD MMM YYYY")),
    size: 150,
  },
  {
    accessorKey: 'validTo',
    header: 'Offer Ends',
    Cell: ({ cell }) => formatCellValue(cell.getValue(),val=> moment(val).format("DD MMM YYYY")),
    size: 150,
  },
  {
    accessorKey: "status",
    header: "Status",
    size: 150,
    Cell: ({ row, cell }) => {
      const validTo = row.original.validTo;
      const isExpired =
        moment(validTo).isValid() && moment(validTo).isBefore(moment(), "day");

      let statusValue = cell.getValue();          // e.g. "Successful"

      if (validTo !== "0001-01-01T00:00:00Z" && isExpired) {
        statusValue = "INACTIVE";
      }
      return <StatusBadge value={statusValue} />;
    },
  }   ,
  {
    accessorKey: 'addOnOffer',
    header: 'Type',
    size: 150,
    Cell: ({ cell }) => cell.getValue() ? 'Add-On' : 'Base Offer',
  },
  {
    accessorKey: 'serviceBarred',
    header: 'Service Barred',
    size: 150,
    Cell: ({ cell }) => cell.getValue() ? 'Yes' : 'No',
  }
];